<div class="cart" [ngClass]="{'no-items': cart.itemDetails?.length === 0}">
  @if (loadingCart) {
    <div class="cart--loader">
      <div class="loading-animation"></div>
    </div>
  }
  <div class="cart--header">
    <h6 class="cart-name">{{ cartName(cart) }}</h6>
    <button type="submit" class="button button--link button--delete-cart"
      [attr.data-test]="'button-delete-' + cart.id"
      (click)="deleteCart(cart.id, cart.attributes.totalItemsQuantity)">
      {{ 'multi-cart.delete-cart' | translate }}
      <span class="icon-close"></span>
    </button>
  </div>
  <div class="cart--body">
    @if (cart.itemDetails[0]?.id) {
      <div class="cart-image">
        <img [src]="getImageForCart(cart.itemDetails[0]?.id)" alt="{{ cart.itemDetails[0]?.attributes.abstractSku }}">
      </div>
    }
    <div class="cart-items">
      <h6 class="cart-item-name">{{ cart.id }}</h6>
      @if (cart.itemDetails?.length > 0) {
        <strong>
          {{ singularOrPlural(cart.itemDetails.length, 'orders-page.item') | translate: {number: cart.itemDetails.length} }}
        </strong>
        @if (isSapStore) {
          @if (cart.attributes.systemDetails?.nameEnUs) {
            <span>
              {{ cart.attributes.systemDetails?.nameEnUs }}
            </span>
          }
          @if (cart.attributes.systemDetails?.siemensEquipmentId) {
            <span>
              FL: {{ cart.attributes.systemDetails?.siemensEquipmentId }}
            </span>
          }
        }
      } @else {
        <span>{{ 'multi-cart.no-cart-items' | translate }}</span>
      }
    </div>
    <div class="cart-actions">
      @if (cart.itemDetails?.length > 0) {
        <button
          type="submit" class="button button--primary" [attr.data-test]="'button-continue-' + cart.id"
          (click)="switchCart(cart.id, true)">
          {{ 'multi-cart.continue' | translate }}
        </button>
      }
      <button type="submit" class="button" [attr.data-test]="'button-select-' + cart.id"
        (click)="switchCart(cart.id)">
        {{ 'multi-cart.select' | translate }}
      </button>
    </div>
  </div>
</div>
